export default function MainPic() {
    return (
        <>
       <svg className="wave overflow-hidden" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 300" width={'100%'}>
    <path fill="#247b6aff" d="M0,50 Q150,0 300,50 Q450,100 600,50 Q750,0 900,50 Q1050,100 1200,50 V250 Q1050,200 900,250 Q750,300 600,250 Q450,200 300,250 Q150,300 0,250 Z" />
</svg>

        </>
    )
    }